// // import styles from "./CapacityCards.module.css";

// // const icons = {
// //   theatre: "🎭",
// //   classroom: "👨‍🏫",
// //   u_shape: "⭕",
// //   boardroom: "💼",
// //   round_table: "🪑",
// //   banquet: "🍽",
// //   cocktail: "🥂",
// //   cluster: "👥",
// // };

// // const labels = {
// //   theatre: "Theatre",
// //   classroom: "Classroom",
// //   u_shape: "U Shape",
// //   boardroom: "Boardroom",
// //   round_table: "Round Table",
// //   banquet: "Banquet",
// //   cocktail: "Cocktail",
// //   cluster: "Cluster",
// // };

// // export default function CapacityCards({ ballroom  }) {

// //   if (!ballroom) return null;

// //   return (
// //     <section className={styles.section}>
// //       <div className={styles.container}>

// //         <h2 className={styles.heading}>
// //           Seating Capacity
// //         </h2>

// //         <div className={styles.grid}>

// //           {ballroom.capacities.map((item) => (
// //             <div key={item.id} className={styles.card}>

// //               <div className={styles.icon}>
// //                 {icons[item.seating_type]}
// //               </div>

// //               <h3>
// //                 {labels[item.seating_type]}
// //               </h3>

// //               <p>
// //                 {item.capacity}
// //               </p>

// //             </div>
// //           ))}

// //         </div>

// //       </div>
// //     </section>
// //   );
// // }
// import styles from "./CapacityCards.module.css";

// const icons = {
//   theatre: "🎭",
//   classroom: "👨‍🏫",
//   u_shape: "⭕",
//   boardroom: "💼",
//   round_table: "🪑",
//   banquet: "🍽",
//   cocktail: "🥂",
//   cluster: "👥",
// };

// const labels = {
//   theatre: "Theatre",
//   classroom: "Classroom",
//   u_shape: "U Shape",
//   boardroom: "Boardroom",
//   round_table: "Round Table",
//   banquet: "Banquet",
//   cocktail: "Cocktail",
//   cluster: "Cluster",
// };

// export default function CapacityCards({ ballroom  }) {

//   if (!ballroom) return null;

//   return (
//     <section className={styles.section}>
//       <div className={styles.container}>

//         <h2 className={styles.heading}>
//           Seating Capacity
//         </h2>

//         <div className={styles.grid}>

//           {/* {ballroom.capacities.map((item) => (
//             <div key={item.id} className={styles.card}>

//               <div className={styles.icon}>
//                 {icons[item.seating_type]}
//               </div>

//               <h3>
//                 {labels[item.seating_type]}
//               </h3>

//               <p>
//                 {item.capacity}
//               </p>

//             </div>
//           ))} */}
// {[...ballroom.capacities]
//   .sort((a, b) => b.capacity - a.capacity)
//   .map((item) => (
//     <div key={item.id} className={styles.card}>

//       <div className={styles.icon}>
//         {icons[item.seating_type]}
//       </div>

//       <h3>
//         {labels[item.seating_type]}
//       </h3>

//       <p>
//         {item.capacity}
//       </p>

//     </div>
//   ))}

//         </div>

//       </div>
//     </section>
//   );
// }


import React from "react";
import styles from "./CapacityCards.module.css";
import SeatingLayoutIcon from "./SeatingLayoutIcon";

const labels = {
  theatre: "Theatre",
  classroom: "Classroom",
  u_shape: "U-Shape",
  boardroom: "Boardroom",
  round_table: "Round Table",
  banquet: "Banquet",
  cocktail: "Cocktail",
  cluster: "Cluster",
  e_shape: "E-Shape",
  t_shape: "T-Shape",
};

export default function CapacityCards({ ballroom }) {
  if (!ballroom) return null;

  const capacities = [...(ballroom.capacities || [])].sort(
    (a, b) => Number(b.capacity || 0) - Number(a.capacity || 0)
  );

  if (!capacities.length) return null;

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        <h2 className={styles.heading}>Seating Capacity</h2>

        <div className={styles.grid}>
          {capacities.map((item) => {
            const label =
              labels[item.seating_type] ||
              item.seating_type?.replace(/_/g, " ") ||
              "Other";

            return (
              <div key={item.id} className={styles.card}>
                <div className={styles.icon}>
                  <SeatingLayoutIcon type={item.seating_type} />
                </div>

                <h3>{label}</h3>
                <p>{item.capacity}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
